frappe.provide('ftcore');

/**
 * Moving a portal's status pill in place, once an answer has been recorded.
 *
 * A supplier who declines or approves on a tokenised portal has just told us something. Leaving the
 * pill reading "Pending" until they think to reload puts them in the one position the page exists to
 * avoid: unsure whether we heard them. Some will answer twice to be safe, which is a second workflow
 * transition and a second email.
 *
 * **This reflects a write; it does not make one.** The status is already saved by the time this runs
 * — `email_table.quote_request_status` on the quote side, `purchase_orders.supplier_response` on the
 * order side — and the endpoints hand back what they stored so the caller can pass it in. That is
 * deliberate: the pill must never show a word the server did not agree to, or a supplier reads
 * "Approved" off a submission that failed. Reload the page and you get the same value from the
 * database, because it came from there.
 *
 * Loaded on web portals via `ct_website.bundle.js`; the pill it moves is rendered by
 * `templates/portal/portal_macros.html` → `status_badge`, which carries the `js-ftp-status` hook for
 * exactly this.
 */

//: The tone classes `status_badge` can carry. Listed so an update can take the old one off without
//: knowing which it was — a blind `removeClass` needs the full set, and a regex over the class
//: attribute would also match `ftp-badge` itself.
const BADGE_TONES = ["ok", "danger", "warn", "info", "neutral"];

/**
 * Update the portal's status pill.
 *
 * @param {string} status - The status to show, as the SERVER recorded it. Rendered as given.
 * @param {object} [tones] - `{status: tone}`, from `page_context.status_tones`. A status the map does
 *      not name falls back to `neutral` — a plain grey chip, which reads as "we do not know" rather
 *      than borrowing whatever tone was there before.
 * @returns {boolean} Whether a pill was found and updated. False on a page that renders no badge,
 *      which is not an error — the caller has nothing to do about it.
 */
ftcore.set_portal_status = function (status, tones) {
    const $badge = $(".js-ftp-status").first();
    if (!$badge.length || !status) return false;

    const tone = (tones || {})[status] || "neutral";

    BADGE_TONES.forEach(name => $badge.removeClass("ftp-badge--" + name));
    $badge.addClass("ftp-badge--" + tone);

    // `.text()`, never `.html()`: this value crosses from a JSON response into the DOM, and while it
    // comes from a server-side constant today, a text node cannot become markup if that ever stops
    // being true.
    $badge.text(status);
    return true;
};
